import React from 'react';

import styles from './Labels.scss';
import cls from 'classnames';
import { ACTIVITY_TYPES, LABEL_TYPES, MINI_GROUP_ID } from '../../constants';
import { Activity } from '../../types';

type Props = {
  className?: string;
} & Pick<Activity, 'discount' | 'type' | 'categories'>;

const ACTIVITY_TYPES_TO_SHOW = {
  [ACTIVITY_TYPES.INDIVIDUAL]: 'Индивидуальная',
  [ACTIVITY_TYPES.GROUP]: 'Мини-группа',
};

type Label = {
  type: string;
  text: string;
};

const Labels = ({ className, discount, type, categories }: Props) => {
  const labelsToShow: Label[] = [];

  if (discount) {
    labelsToShow.push({
      type: LABEL_TYPES.DISCOUNT,
      text: `-${Math.trunc(discount * 100)}%`,
    });
  }

  if (
    type === ACTIVITY_TYPES.INDIVIDUAL ||
    (type === ACTIVITY_TYPES.GROUP && categories?.some((category) => category.id === MINI_GROUP_ID))
  ) {
    labelsToShow.push({
      type: LABEL_TYPES.ACTIVITY_TYPE,
      text: ACTIVITY_TYPES_TO_SHOW[type],
    });
  }

  return (
    <div className={cls(styles.container, className)}>
      {labelsToShow.map((label) => {
        return (
          <div key={label.type} className={cls(styles.label, styles[label.type])}>
            {label.text}
          </div>
        );
      })}
    </div>
  );
};
export default Labels;
